import { Text as NativeText } from 'react-native';
import { createSafeStyledView } from '../css/createSafeStyledView';
const Text = NativeText;
export default createSafeStyledView(Text);
//# sourceMappingURL=Text.js.map